import { Resourceful } from "../../ResourceManager/Resourceful";
import { IReadOnlyResourceManager, ResourceManager } from "../../ResourceManager/ResourceManager";
import { SpriteResource } from "../../ResourceManager/SpriteResource";
import { ISystemContext } from "../../Context/SystemContext";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { Size, CreateElement, Scale, Log, LogGroup } from "../../MyHelpers";
import { PixiSpriteResource } from "../../ResourceManager/PixiSpriteResource";
import { CanvasSprite } from "../Sprite/CanvasSprite";
import { titleParamsFeature } from "./titleParamsFeature";
import { ITitleGeneric } from "./ITitleGeneric";
import { IRandomInterval } from "../../Context/RandomInterval";

export class titleGame  implements ITitleGeneric{

    protected gameTitleSprite : PixiSpriteResource;
    protected jackpotTitleSprite : SpriteResource;
    protected systemContext : ISystemContext;
    protected logGroup  : LogGroup ;
    protected viewSize : Size;
    protected resid : ResourceIdentifier;
    protected view : HTMLElement  = null;
    protected titleSprite  : CanvasSprite;
    // protected titleJackpotSprite  : CanvasSprite;
    protected titleSpriteDelayTimer: IRandomInterval;
    protected basePath:string;
    protected gameName:string;
    
    constructor(params: titleParamsFeature) {
        //this.gameTitleSprite = params.gameTitleSprite;
        //this.jackpotTitleSprite = params.jackpotTitleSprite;
        this.systemContext = params.systemContext;
        this.logGroup = params.LogGroup;
        //this.viewSize = params.viewSize;
        this.resid = params.resid;
        this.basePath = params.basePath;
        this.gameName = params.gameName;        
        this.view = CreateElement("div", {
            classes: ["jackpotTitleSlide"],
            style: {
                width : "100%",
                height : Scale.Hpx(460),
                display : "flex",      
                backgroundColor : "rbga(0,0,0,0.5)",          
            }
        })
    }

    public PrepareResources(resourceManager: ResourceManager) {
        resourceManager.Add(new PixiSpriteResource(this.basePath + "resources/title_sprite2", this.resid.Add(this.gameName).Add("title-SlideGame"), true, this.logGroup.Add("title-SlideGame"), true));
    }

    public ResourcesLoaded(resourceManager: IReadOnlyResourceManager) {
        this.titleSprite = new CanvasSprite({sprite: resourceManager.Get<PixiSpriteResource>(this.resid.Add(this.gameName).Add("title-SlideGame")).sprite, canvasSize: new Size(Scale.W(1920), Scale.H(460))});
        this.view.appendChild(this.titleSprite.View());        
        this.titleSprite.Scale(1.1);
        this.titleSprite.View().style.position = "absolute";  
        
        this.titleSpriteDelayTimer = this.systemContext.TimingContext().CreateRandomInterval("titleSpriteDelay", 2000, 5000, () => this.titleSprite.Start(false));
    }  

    public Update(){
        this.titleSprite.Update();
        // this.titleJackpotSprite.Update();
    }

    public View() : HTMLElement{
        return this.view
    } 
    
    public Start(): void {
    this.titleSpriteDelayTimer.Start();
    }

    public Stop(): void {
		this.titleSpriteDelayTimer.Stop();
    }

}